import React from 'react'
import { Button } from '@/components/ui/button'
import { NameDto } from 'api/Common/Types'
import { TickmillCompanyDto } from 'api/Identity/Types/Company'
import { SubscriptionPlatformDto } from 'api/Trading-Accounts/Types/SubscriptionDetailsDto'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseErrorMessage,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormSubmitValues } from 'utils/formValidation'

export interface SubscriptionPlatformValues {
  subscriptionId: string
  platformType: number
  tickmillCompany: number
}

export const SubscriptionsDetailsMainFormUI: React.FC<
  FormikProps<SubscriptionPlatformValues> & OuterProps
> = (props) => {
  const {
    tickmillCompanies,
    platforms,
    handleSubmit,
    errors,
    isSubmitting,
    onSubscriptionPlatform,
    setFieldValue,
  } = props

  const handleSubmitForm = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    handleSubmit()
  }

  const handleCompany = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('platformType', event.target.value)
    onSubscriptionPlatform(Number.parseInt(event.target.value, 10))
  }

  return (
    <FormBaseContainer>
      <Form onSubmit={handleSubmitForm}>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Tickmill Company</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field component='select' name='platformType' onChange={handleCompany}>
                <option value=''>None</option>
                {tickmillCompanies.map((x) => (
                  <option key={x.id} value={x.id}>
                    {x.name}
                  </option>
                ))}
              </Field>
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.platformType && (
            <FormBaseErrorMessage>{errors.platformType}</FormBaseErrorMessage>
          )}
        </FormBaseFieldBlock>

        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Platform</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field component='select' name='tickmillCompany'>
                <option value=''>None</option>
                {platforms.map((x) => (
                  <option key={x.id} value={x.id}>
                    {x.name}
                  </option>
                ))}
              </Field>
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.tickmillCompany && (
            <FormBaseErrorMessage>{errors.tickmillCompany}</FormBaseErrorMessage>
          )}
        </FormBaseFieldBlock>

        <FormBaseButtonContainer>
          <Button disabled={isSubmitting} type='submit'>
            Save
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

interface OuterProps {
  subscription: SubscriptionPlatformDto | undefined
  tickmillCompanies: TickmillCompanyDto[]
  platforms: NameDto[]
  isNew?: boolean

  onSubscriptionPlatform(tickmillCompanyId: number): void
  onSubmit(values: FormSubmitValues<SubscriptionPlatformValues>): Promise<void>
}

const initialSubscriptionDetailState = (
  subscription: SubscriptionPlatformDto | undefined
): SubscriptionPlatformValues => {
  return {
    subscriptionId: subscription?.subscriptionId || '',
    platformType: subscription?.platformType?.id || 0,
    tickmillCompany: subscription?.tickmillCompany?.id || 0,
  }
}

export const SubscriptionsPlatformForm = withFormik<OuterProps, SubscriptionPlatformValues>({
  mapPropsToValues: ({ subscription }) => {
    return initialSubscriptionDetailState(subscription)
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      setSubmitting(true)
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<SubscriptionPlatformValues> = {}

    if (!values?.platformType) {
      errors.platformType = 'Required'
    }

    if (!values?.tickmillCompany) {
      errors.tickmillCompany = 'Required'
    }

    return errors
  },
  isInitialValid: false,
  enableReinitialize: true,
})(SubscriptionsDetailsMainFormUI)
